export const baseUrl = '/report'
